import { useState } from 'react'
import { Icons } from '@journ/ui/icons'
import { Link } from '@/libs/router'
import { tv } from '@/libs/tv'
import { MainMenu } from './main-menu'

const sidebar = tv({
	base: 'h-screen shrink-0 flex-col justify-between top-0 pb-4 items-center hidden md:flex z-50 bg-background border-r border-border transition-all duration-200 ease-move',
	variants: {
		expanded: {
			true: 'w-60',
			false: 'w-17.5',
		},
	},
})

const logoBar = tv({
	base: 'absolute top-0 left-0 h-17.5 flex items-center justify-center bg-background border-b border-border transition-all duration-200 ease-move',
	variants: {
		expanded: {
			true: 'w-full',
			false: 'w-17.25',
		},
	},
})

const Sidebar = () => {
	const [isExpanded, setIsExpanded] = useState(false)

	return (
		<aside
			className={sidebar({ expanded: isExpanded })}
			onMouseEnter={() => setIsExpanded(true)}
			onMouseLeave={() => setIsExpanded(false)}
		>
			<div className={logoBar({ expanded: isExpanded })}>
				<Link to='/' className='absolute left-5.5 transition-none'>
					<Icons.LogoSmall />
				</Link>
			</div>
			<div className='flex flex-col w-full pt-17.5 flex-1 border-b border-border mb-3'>
				<MainMenu isExpanded={isExpanded} />
			</div>
		</aside>
	)
}

export { Sidebar }
